import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function DeliveryEzyTermsConditions() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="w-screen bg-white py-10 lg:py-16 xl:py-24 px-4 lg:px-16 xl:px-24 text-gray-900">
            <div className="py-16">
                <div>
                    <h1 className="text-4xl font-bold mb-8 text-center">
                        TERMS AND CONDITIONS FOR DELIVER EZY
                    </h1>
                    <section>

                        <p>
                            Welcome to Deliver Ezy. These Terms and Conditions ("Terms") govern your use of the Deliver Ezy platform
                            (“Platform”) provided by Harvey Norman Stores (N.Z.) Pty Limited ("Harvey Norman," "we," "our," or
                            "us"), where we allocate delivery job to delivery agents ("Delivery Agent," "you," or "your") for the
                            purpose of fulfilling delivery orders for our Customers.
                            Please read these Terms carefully before you start using the Platform. By accessing or using the
                            Platform, you agree to comply with and be bound by these Terms and all applicable laws and regulations.
                            If you do not agree with these Terms, you must not use the Platform.

                        </p>
                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase"> Definitions </h3>
                        <p><strong>"Customer"</strong> means any customers of Harvey Norman who require goods to be delivered.</p>
                        <p>&nbsp;</p>
                        <p><strong>"Delivery Agent"</strong> means a delivery agent and their employees and contractors, who use the
                            Platform to receive and complete delivery jobs on behalf of the Harvey Norman.</p>
                        <p>&nbsp;</p>
                        <p><strong>"Delivery Jobs"</strong> means delivery jobs for Harvey Norman customers that are assigned to
                            Delivery Agents through the Platform by Harvey Norman.</p>
                        <p>&nbsp;</p>
                        <p><strong>"Delivery Services"</strong>" means the delivery services provided by the Delivery Agent to
                            Harvey Norman via the Platform.</p>
                        <p>&nbsp;</p>
                        <p><strong>"Platform"</strong> refers to Deliver Ezy and any associated website, software, services, or
                            systems used for assigning delivery jobs to Delivery Agents.</p>
                        <p>&nbsp;</p>
                        <p><strong>"User"</strong> refers to any individual, company or organisation who has created a Deliver Ezy
                            account to allow them to access or use the Platform.</p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">1.</span>
                            <span>Platform Overview</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">1.1.</span>
                            <span>The Platform is owned and operated by
                                Harvey Norman and connects Delivery Agents with Delivery Jobs for Harvey Norman Customers.
                                The Platform assigns and manages Delivery Jobs, with the intention to provide an efficient and
                                transparent method of completing deliveries for Harvey Norman.
                            </span>
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">2.</span>
                            <span>Independent Contractor Relationship</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">2.1</span>
                            <span>As a Delivery Agent, you are an independent contractor and not an employee, contractor, agent, joint
                                venturer, or partner of Harvey Norman.
                                You are responsible for:
                            </span>
                        </p>

                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(a)</span>
                                <span>the management and direction of your employees and contractors;
                                </span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(b)</span>
                                <span>the supply of all vehicles, equipment
                                    and personnel to perform Delivery Services;
                                </span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(c)</span>
                                <span>for all costs related to the supply,
                                    operation, maintenance and insurance of all vehicles and equipment used for Delivery Services;
                                </span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(d)</span>
                                <span>payment of your own expenses and
                                    taxes, and any other legal obligations (including GST) if applicable.
                                </span>
                            </li>

                        </ul>
                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">3.</span>
                            <span>Eligibility</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.1.</span>
                            <span>To be eligible to use the Platform,
                                you must;</span>
                        </p>

                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(a)</span> have entered into a valid and legally binding agreement with Harvey
                                Norman for the provisions of delivery services;
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(b)</span>
                                <span>be at least 18 years old;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(c)</span>
                                <span>hold a valid and current driver’s
                                    license appropriate for the type of vehicle intended to be used for performing Delivery Services;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(d)</span>
                                <span>hold any additional licenses or
                                    certifications required by law to provide Delivery Services, including a goods and services license
                                    issued by New Zealand Land Transport (if applicable);
                                </span>
                            </li>

                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(e)</span>
                                <span>ensure that the vehicle being used for Delivery Service is legally registered, insured, and suitable;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(f)</span>
                                <span>comply with all applicable laws, regulations, codes and standards;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(g)</span>
                                <span>meet any other requirements as specified by Harvey Norman.</span>
                            </li>
                        </ul>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">3.2.</span>
                            <span>Harvey Norman reserves the right to refuse or deactivate the access to the Platform if any eligibility requirements are not met.</span>
                        </p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">4.</span>
                            <span>User Account</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">4.1</span>
                            <span>To use the Platform, you must create a User account which includes agreeing to these Terms. You agree to provide accurate and complete information and to update your information promptly when any changes occur during your use of the Platform.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">4.2</span>
                            <span>You must ensure that your employees or contractors, who will be using the Platform and performing Delivery Services, have separate User accounts. You agree to ensure that each employee and contractor User account is accurate and up to date. If an employee or contractor is no longer authorised to use the Platform, you will notify us immediately so we can deactivate the User account.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">4.3</span>
                            <span>All Users are responsible for maintaining the confidentiality of their account login credentials (such as username and password) and for all activities that occur under the account. If any Users suspect unauthorised use of their account or a security breach, they must notify Harvey Norman immediately.</span>
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">5.</span>
                            <span>User Responsibilities</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.1.</span>
                            <span>All Users agree to:</span>
                        </p>
                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(a)</span>
                                <span>provide accurate and complete information when using the Platform;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(b)</span>
                                <span>comply with all applicable laws, regulations, codes and standards and hold all necessary licenses while using the Platform;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(c)</span>
                                <span>use the Platform only for its intended purpose and comply with all instructions and notifications provided within the Platform or by Harvey Norma</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(d)</span>
                                <span>access and use the Platform in a responsible, lawful, and ethical manner;</span>
                            </li>

                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(e)</span>
                                <span>prevent any unauthorised access to, or use of the Platform.</span>
                            </li>

                        </ul>



                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">5.2.</span>
                            <span>All Users agree not to engage in the following prohibited behaviour when using the Platform:</span>
                        </p>
                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(a)</span>
                                <span>any unlawful, fraudulent, or malicious activities;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(b)</span>
                                <span>misuse the Platform including attempting to gain unauthorised access to any part of the Platform, accounts, or systems.</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(c)</span>
                                <span>uploading or posting any content to the Platform that is unlawful, threatening, defamatory, offensive, obscene, objectional or which infringe any intellectual property or legal rights of any third party;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(d)</span>
                                <span>any activity that could disrupt, damage, or interfere with the proper functioning of the Platform, including hacking, spreading viruses, overloading the Platform or any other action that negatively impacts the operation or performance of the Platform;</span>
                            </li>

                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem] ">(e)</span>
                                <span>copy, publish, modify, distribute, sell, sublicence, reverse engineer, create derivative works or commercially exploit any part of the Platform or associated content</span>
                            </li>

                        </ul>
                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start"> 
                            <span className="min-w-[2rem]">6.</span>
                            <span>Access and Use of the Platform</span>
                        </h3>

                        <p>Harvey Norman grants each User a limited, non-exclusive, non-transferable right to access and use the Platform solely for the purpose of performing Delivery Jobs assigned to them by the Platform. Each User’s access to and use of the Platform is granted on the condition that they comply with these Terms, Harvey Norman policies, and any applicable laws.</p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">7.</span>
                            <span>Delivery Assignments</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.1.</span>
                            <span>The Platform assigns Delivery Jobs to Delivery Agents. When a Delivery Job is assigned to you, you will be notified through the Platform. Each Delivery Job will have specific details of the delivery, including the pickup location, delivery address of the Customer, the goods to be delivered and any additional delivery instructions.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.2.</span>
                            <span>Once you have been assigned a Delivery Job, you are expected to complete the delivery as per the delivery instructions specified by Harvey Norman, including any delivery timeframes or specific delivery instructions. If you unable to complete the Delivery Job, you must cancel the Delivery Job immediately, so it can be re-assigned to another Delivery Agent.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">7.3.</span>
                            <span>Harvey Norman reserves the right to modify or cancel Delivery Jobs at its discretion, at any time, without reason.</span>
                        </p>
                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">8.</span>
                            <span>Delivery Standards and Conduct</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem] ">8.1.</span>
                            <span>You agree to the following standards of conduct when performing the Delivery Services:</span>
                        </p>

                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(a)</span>
                                <span>you will adhere to all New Zealand road safety laws and regulations, licensing requirements, driving rules and other applicable laws and regulations;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(b)</span>
                                <span>not to accept or complete a Delivery Job that you are not capable of completing;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(c)</span>
                                <span>completing all Delivery Jobs in a safe, timely and efficient manner and in accordance with delivery instructions and within the agreed timeframes;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(d)</span>
                                <span>communicate in a clear and timely manner with the Customer regarding the delivery status, estimated time of delivery and any delivery issues that may arise;</span>
                            </li>

                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(e)</span>
                                <span>ensure that the goods are delivered to the correct delivery address and that they are in the same condition as when they were uplifted from the pickup location;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(f)</span>
                                <span>not engage in fraudulent activities, including misrepresenting the delivery status or falsifying delivery information such as proof of delivery;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(g)</span>
                                <span>at all times exercise reasonable care and skill and conduct yourself in a professional and courteous manner when interacting with Customers and Harvey Norman staff.</span>
                            </li>

                        </ul>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">8.2.</span>
                            <span>Failure to comply with these standards may result in the suspension or deactivation of your access to the Platform and/or the termination of your agreement with Harvey Norman.</span>
                        </p>

                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2rem]">9.</span>
                            <span>Delivery</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.1</span>
                            <span>Upon being assigned a Delivery Job, you are responsible for:</span>
                        </p>
                        <ul className="list-style:none; ml-8 lg:ml-14 mb-4">
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(a)</span>
                                <span>collecting the goods from the designated pickup location;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(b)</span>
                                <span>transportation of the goods in a safe, secure and timely manner, to the delivery address within any delivery timeframes;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(c)</span>
                                <span>delivering the goods to the Customer at the delivery address, in accordance with any specific delivery instructions;</span>
                            </li>
                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(d)</span>
                                <span>obtaining evidence of proof of delivery and uploading it to the Platform;</span>
                            </li>

                            <li className=" flex items-start mb-2">
                                <span className=" min-w-[2rem]">(e)</span>
                                <span>notifying us of any non-deliveries or any issues during the delivery such as damaged goods.</span>
                            </li>


                        </ul>


                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.2.</span>
                            <span>For all completed Delivery Jobs, you agree that as proof of delivery,
                                you must obtain the Customer’s signature confirming receipt of the goods, with the option to include a photograph of the goods delivered to the Customer’s address, showing the condition of the goods and the delivery location. You must ensure that the photograph does not capture or identify any individual, personal or confidential information, or any other private or sensitive information that could infringe on the privacy rights of the individual or others.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.3</span>
                            <span>Proof of delivery must be uploaded to the Platform immediately after the completion of each delivery and serves as evidence that the Delivery Job has been successfully completed. The Delivery Job must be marked as “complete” in the Platform.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.4</span>
                            <span>Failure to upload proof of delivery in a timely manner may result in non-payment for the Delivery Job. Harvey Norman reserves the right to request additional proof of delivery documents if necessary.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.5</span>
                            <span>You are responsible for ensuring the accuracy and integrity of all proof of delivery documents. Any attempt to falsify or alter proof of delivery documents may result in the termination of your service agreement with Harvey Norman.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.6</span>
                            <span>If you have taken a photograph of proof of delivery on your device, upon a successful upload to the Platform, you are required to permanently delete the photograph from your device. You agree that no photographs related to Delivery Jobs shall remain on your device after it has been uploaded. This is to ensure compliance with the Privacy Act 2020.</span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2rem]">9.7</span>
                            <span>If you are unable to deliver the goods to the Customer for any reason e.g. Customer unavailable or incorrect address, you must immediately contact the Harvey Norman store/warehouse where the goods were picked up from and inform them of the reason for the non-delivery. You must follow the instructions of the store/warehouse on how to procced, which may include attempting redelivery of the goods.</span>
                        </p>

                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">10.</span>
                            <span>No Guarantee of Delivery Jobs</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">10.1.</span>
                            <span>By using the Platform, you understand and agree that Harvey Norman reserves the right to assign Delivery Jobs at its discretion based on availability and other factors. You are not guaranteed a minimum number of delivery jobs by Harvey Norman.</span>
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">11.</span>
                            <span>Customer Disputes</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">11.1</span>
                            <span></span>You agree to notify Harvey Norman immediately of any actual or potential Customer dispute or complaint regarding the Delivery Job. You agree to cooperate fully with Harvey Norman in the investigation and resolution of the dispute or complaint, which includes providing any information, documentation of other assistance as requested by Harvey Norman.
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">12.</span>
                            <span>Platform Availability</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">12.1</span>
                            <span>Harvey Norman does not warranty or guarantee that the Platform will be available at all times or that the access and functionality will be uninterrupted and error-free. Harvey Norman does not accept any responsibility or liability for any errors, delays, downtime or disruptions when using the Platform. Harvey Norman reserves the right to modify, suspend, or discontinue the Platform or any part of it at any time without prior notice.</span>
                        </p>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">12.2</span> To the fullest extent permitted by law, the Platform is provided on an "as is" and “as available” basis and Harvey Norman makes no representations or warranties of any kind, express or implied, including but not limited to any implied warranties of merchantability, fitness for a particular purpose, or non-infringement, as well as any warranties that the Platform will be free from interruptions and errors
                        </p>


                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">13.</span>
                            <span>Suspension and Deactivation of Access</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">13.1</span>
                            <span>Harvey Norman reserves the right to suspend or deactivate any User’s access to the Platform at any time and without notice, if Harvey Norman reasonably believes that they breach any of the Terms or engaged in prohibited conduct. Harvey Norman may also limit or restrict access to certain features of the Platform in its sole discretion. If you access is suspended or deactivated, you must immediately cease using the Platform.</span>
                        </p>

                    </section>

                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">14.</span>
                            <span>Privacy</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">14.1</span>
                            <span>
                                You agree to comply with the provisions of the Privacy Act 2020 in relation to the collection, use, storage, and deletion of Customer personal information. Customer personal information includes names, contact details, delivery address, delivery information and photographs of goods delivered. You agree that Customer personal information disclosed to you through the Platform, will only be used for and retained for the purpose of performing the Delivery Job. You must ensure that this information is stored securely and protected from unauthorised access, alteration or disclosure. Once the Delivery Job has been completed, you will ensure that all Customer personal information is securely deleted.

                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">14.2</span>
                            <span>
                                You agree to notify Harvey Norman immediately if you become aware of any actual or suspected privacy or data breach related to the use of the Platform. This includes but is not limited to, any unauthorised access or disclosure of Customer personal information. When notifying Harvey Norman of any breach or potential breach, you must provide full details of the incident including the nature of the breach, the personal information or data involved and any other relevant information.
                            </span>
                        </p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">15.</span>
                            <span>Confidentiality</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">15.1.</span>
                            <span>
                                You acknowledge that while using or accessing the Platform, you may have access to confidential, proprietary or sensitive information of Harvey Norman. You agree to maintain the confidentiality of this confidential information and not to disclose, share, or otherwise make available such information to any third party without the prior written consent of Harvey Norman. You agree to only use the confidential information solely for the purpose of using the Platform and not for any other purpose.
                            </span>
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">16.</span>
                            <span>Security and Data Protection</span>
                        </h3>

                        <p>
                            While we take reasonable measures to protect the security and privacy of your information and data, unfortunately no system or platform can be guaranteed as completely secure. Accordingly, we cannot warrant that any content or information you transmit to or through the Platform is totally secure, free from viruses, bugs, fault or other conditions which could damage or interfere with your computer system. You therefore use our Platform at your own risk. You agree to notify us if you believe your data has been compromised.
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">17.</span>
                            <span>Intellectual Property</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">17.1</span>
                            <span>
                                The Platform is owned, designed and maintained by Harvey Norman. All rights, title and interest in and to all intellectual property, including but not limited to all software, source code, design, user interface, copyrights, trademarks, patents, trade secrets and any other proprietary rights integrated or incorporated into the Platform, is owned exclusively by Harvey Norman.

                            </span>
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">18.</span>
                            <span>Indemnity and Liability</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">18.1</span>
                            <span>
                                You agree to indemnify and keep indemnified Harvey Norman and its officers, employees, and agents in respect of any claims made upon or against them for any damage, loss, cost or expense (including reasonable legal costs and expenses) arising from or in connection with your use of the Platform or a breach of these Terms.
                            </span>
                        </p>
                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">18.2</span>
                            <span>
                                To the fullest extent permitted by law, Harvey Norman is not liable, in contract, tort (including negligence), or otherwise, to Delivery Agents, Users or any third party for any damages, loss or claims arising from or in connection with the Platform (including system failures) or a breach of these Terms, including but not limited to any loss of profits, loss of revenues, loss of contract, loss of business, lost data (whether direct or indirect) or any indirect or consequential loss.
                            </span>
                        </p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">19.</span>
                            <span>Dispute Resolution</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">19.1</span>
                            <span>
                                In the case of any dispute arising from or relating to these Terms or your use of the Platform, you agreed to attempt to resolve the dispute through good faith negotiations. If the dispute cannot be resolved through good faith negotiations, within twenty (20) business days then you agree to follow the dispute resolution process set out in your agreement with Harvey Norman.
                            </span>
                        </p>


                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">20.</span>
                            <span>Amendments to Terms</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">20.1</span>
                            <span>
                                Harvey Norman reserves the right to update or modify these Terms at any time by publishing an updated version on the Platform. Any changes will be effective immediately and by continuing to use the Platform, you agree to be bound by these updated Terms. You are responsible to review these Terms periodically to ensure you are aware of any amendments.
                            </span>
                        </p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">21.</span>
                            <span>Severability</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">21.1</span>
                            <span>
                                If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will continue in full force and effect.
                            </span>
                        </p>

                    </section>
                    <section>

                        <h3 className="text-2xl font-semibold mt-8 mb-4 uppercase flex items-start">
                            <span className="min-w-[2.6rem]">22.</span>
                            <span>Governing Laws</span>
                        </h3>

                        <p className=" flex items-start mb-2">
                            <span className=" min-w-[2.6rem]">22.1</span>
                            <span>
                                These Terms will be governed by and construed in accordance with the laws of New Zealand. You agree to submit to the non-exclusive jurisdiction of the New Zealand courts to resolve any disputes arising in relation to our Terms or the Platform.
                            </span>
                        </p>


                    </section>

                    <p>&nbsp;</p>

                    <section>

                        <p>These Website Terms were last updated on 2nd May 2025</p>
                    </section>




                </div>
            </div>
        </div>
    );
}
